export enum EChartObservationType {
  BLOOD_PRESSURE_SYSTOLIC = 'BloodPressureSystolic',
  BLOOD_PRESSURE_DIASTOLIC = 'BloodPressureDiastolic',
  BLOOD_PRESSURE = 'BloodPressure',
  BLOOD_SUGAR = 'BloodSugar',
  BODY_HEIGHT = 'BodyHeight',
  BODY_TEMPERATURE = 'BodyTemperature',
  BODY_WEIGHT = 'BodyWeight',
  HEART_RATE = 'HeartRate',
  OXYGEN_SATURATION = 'OxygenSaturation',
  RESPIRATORY_RATE = 'RespiratoryRate',
  SLEEP = 'Sleep',
}
